
import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search, Filter } from 'lucide-react';
import { useRegions } from '@/hooks/useRegions';

interface CountriesFiltersProps {
  searchQuery: string;
  onSearchChange: (search: string) => void;
  selectedRegion: string | null;
  onRegionChange: (region: string | null) => void;
  selectedStatus: string | null;
  onStatusChange: (status: string | null) => void;
  isMobile?: boolean;
}

export const CountriesFilters = ({
  searchQuery,
  onSearchChange,
  selectedRegion,
  onRegionChange,
  selectedStatus,
  onStatusChange,
  isMobile
}: CountriesFiltersProps) => {
  const { regions } = useRegions();

  const handleRegionChange = (value: string) => {
    onRegionChange(value === 'all' ? null : value);
  };

  const handleStatusChange = (value: string) => {
    onStatusChange(value === 'all' ? null : value);
  };

  return (
    <div className="space-y-4 mb-6">
      <div className={`grid gap-4 ${isMobile ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-3'}`}>
        {/* Search input */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search countries..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
          />
        </div>

        {/* Region Filter */}
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-muted-foreground flex-shrink-0" />
          <Select value={selectedRegion || 'all'} onValueChange={handleRegionChange}>
            <SelectTrigger>
              <SelectValue placeholder="All Regions" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Regions</SelectItem>
              <SelectItem value="no-region">No Region</SelectItem>
              {regions
                .filter(region => region.active)
                .map((region) => (
                  <SelectItem key={region.id} value={region.id}>
                    {region.name}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
        </div>

        {/* Status Filter */}
        <div className="flex items-center gap-2">
          <Filter size={16} className="text-muted-foreground flex-shrink-0" />
          <Select value={selectedStatus || 'all'} onValueChange={handleStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="All Status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="active">Active</SelectItem>
              <SelectItem value="inactive">Inactive</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
